export var AssetNameType;
(function (AssetNameType) {
    AssetNameType["StandardResponseToVoeForm"] = "Standard Response To Voe Form";
})(AssetNameType || (AssetNameType = {}));
//# sourceMappingURL=asset.js.map